class BlogPagination extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.init();
  }

  init() {
    const paginationLinks = this.querySelectorAll('a[data-pagination-url]');
    paginationLinks.forEach(link => {
      link.addEventListener('click', this.handlePaginationClick.bind(this));
    });
  }

  handlePaginationClick(event) {
    event.preventDefault();

    const url = event.currentTarget.getAttribute('data-pagination-url');
    if (!url) return;

    this.classList.add('loading');

    const loadingSpinner = this.querySelector('.blog-pagination__loading');
    if (loadingSpinner) {
      loadingSpinner.classList.remove('hidden');
    }

    const paginationLinks = this.querySelectorAll('a[data-pagination-url]');
    paginationLinks.forEach(link => {
      link.style.pointerEvents = 'none';
    });

    const separator = url.includes('?') ? '&' : '?';
    const sectionUrl = `${url}${separator}section_id=${this.sectionId}`;
    
    fetch(sectionUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
        }
        return response.text();
      })
      .then(responseText => {
        this.renderSection(responseText, url);
      })
      .catch(error => {
        window.location.href = url;
      });
  }

  renderSection(html, url) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    let sectionElement = doc.querySelector(`#shopify-section-${this.sectionId}`);
    
    if (!sectionElement) {
      sectionElement = doc.querySelector('.main-blog');
    }
    
    if (!sectionElement) {
      sectionElement = doc.querySelector('[id^="shopify-section-"]');
    }
    
    if (!sectionElement) {
      window.location.href = url;
      return;
    }

    const currentGrid = document.getElementById('product-grid');
    const newGrid = sectionElement.querySelector('#product-grid');
    
    if (currentGrid && newGrid) {
      currentGrid.innerHTML = newGrid.innerHTML;
    }

    const currentPaginationWrapper = document.querySelector('.pagination-wrapper');
    const newPaginationWrapper = sectionElement.querySelector('.pagination-wrapper');
    
    if (currentPaginationWrapper && newPaginationWrapper) {
      currentPaginationWrapper.innerHTML = newPaginationWrapper.innerHTML;
      
      const newBlogPagination = currentPaginationWrapper.querySelector('blog-pagination');
      if (newBlogPagination) {
        newBlogPagination.dataset.sectionId = this.sectionId;
      }
    } else if (currentPaginationWrapper && !newPaginationWrapper) {
      currentPaginationWrapper.remove();
    }

    if (window.history && window.history.pushState) {
      window.history.pushState({}, '', url);
    }

    const blogSection = document.getElementById('ProductGridContainer');
    if (blogSection) {
      const offsetTop = blogSection.offsetTop - 100;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }

    this.classList.remove('loading');
    const loadingSpinner = this.querySelector('.blog-pagination__loading');
    if (loadingSpinner) {
      loadingSpinner.classList.add('hidden');
    }

    const paginationLinks = document.querySelectorAll('blog-pagination a[data-pagination-url]');
    paginationLinks.forEach(link => {
      link.style.pointerEvents = '';
    });

    document.dispatchEvent(new CustomEvent('blog:pagination:updated', {
      detail: { url, sectionId: this.sectionId }
    }));
  }
}

customElements.define('blog-pagination', BlogPagination);

